import get from 'lodash.get';

// Global Types
import { AppState } from 'services/types';

// Global Utils
import createDeepEqualSelector from 'utils/reselect/typescript/createDeepEqualSelector';

// Local Types
import {
    ColumnWidthTableId,
    ColumnWidthColumnName,
    ColumnWidthsState,
    ColumnWidthsProps
} from './types';

const selectColumnWidths = (state: Record<string, any>): ColumnWidthsState =>
    state.columnWidths;

const selectColumnWidthTableId = (
    state: AppState,
    props: ColumnWidthsProps
): ColumnWidthTableId => props.tableId;

const selectColumnWidthColumnName = (
    state: AppState,
    props: ColumnWidthsProps
): ColumnWidthColumnName | undefined => props.columnName;

const selectTableColumnWidths = createDeepEqualSelector(
    [selectColumnWidths, selectColumnWidthTableId],
    (columnWidths, columnWidthTableId) =>
        get(columnWidths, columnWidthTableId, {})
);

const makeSelectTableColumnWidths = (): typeof selectTableColumnWidths =>
    selectTableColumnWidths;

const selectColumnWidthWidth = createDeepEqualSelector(
    [selectColumnWidths, selectColumnWidthTableId, selectColumnWidthColumnName],
    (columnWidths, columnWidthTableId, columnWidthColumnName) => {
        if (columnWidthColumnName) {
            return get(columnWidths, [
                columnWidthTableId,
                columnWidthColumnName
            ]);
        }

        return undefined;
    }
);

const makeSelectColumnWidthWidth = (): typeof selectColumnWidthWidth =>
    selectColumnWidthWidth;

export {
    selectColumnWidths,
    selectColumnWidthTableId,
    selectColumnWidthColumnName,
    selectTableColumnWidths,
    makeSelectTableColumnWidths,
    selectColumnWidthWidth,
    makeSelectColumnWidthWidth
};
